<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    
                    <router-link to="/backoffice/packings/shipping/coupon">
                        <base-button size="md" type="neutral" class="ml-2">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-8">
                <div>
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >
                        <template slot="header">
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <h1>ตรวจสอบสถานะการส่งสินค้า</h1>
                                    <hr/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <!-- <div class="col-md-6">
                                    <base-input
                                        :label="$t('wms.menu.inventory')"
                                    >
                                        <el-select
                                            v-model="params.storage_id"
                                            :label="$t('wms.menu.inventory')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in StorageTable"
                                                :key="option.ID"
                                                :label="option.Name"
                                                :value="option.ID"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div> -->

                                <!-- <div class="col-md-6">
									<base-input :label="$t('shipping_provider')" >
										<el-select v-model=" params.shipping_provider_id " :label="$t('shipping_provider')"  :disabled="lock">
											<el-option v-for="option in ShippingProviderTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
										</el-select>
									</base-input>
								</div> -->

                                <div class="col-md-6">
                                    <base-input :label="$t('platform')">
                                        <el-select
                                            v-model="params.platform_id"
                                            :label="$t('platform')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in PlatformTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-6">
                                    <base-input label="ประเภทบาร์โค้ด">
                                        <el-select
                                            v-model="params.barcode_type"
                                            label="Barcode Type"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in BarcodeTypeTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- Lock -->
                                <div class="col-md-3 py-4">
                                    <base-button
                                        @click="handleUnLock"
                                        v-if="lock"
                                        >UnLock</base-button
                                    >

                                    <!-- Unlock -->
                                    <base-button
                                        @click="handleLock"
                                        v-if="!lock"
                                        >Lock</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="lock">
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                            <div class="col-md-12" v-if="isWait">
                                <span>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    กำลังประมวลผล...</span
                                >
                            </div>

                            <div class="col md-12 mt-3" v-if="isCloseFound">
                                <span class="text-green" v-if="order.order_status == 130 || order.order_status == 121">Order Status : {{ order_status }} ({{ order.order_status }}) </span>
                                <span class="text-red" v-else>Order Status : {{ order_status }} ({{ order.order_status }}) </span>

                                <br>

                                Order : {{ order.ID }} <br>
                                Tracking : {{ order.shipping_tracking_number }}<br>
                                <br>

                                <div v-for="p in products.products" :key="p.id">
                                    <div>{{ p.quantity }} x {{ p.name}} </div>
                                </div>
                                <br>
                                <div v-for="p in wms_items" :key="p.barcode">
                                    <div>{{ p.pickup_quantity }} x {{ p.wms_product_name}} </div>
                                </div>
                                <br>

                                <div v-for="c in coupons" :key="c">
                                    <div>คูปอง : {{ c.running_number}} </div>
                                </div>
                            </div>



                        </div>

                        <!-- Show Order ID -->
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-8" v-if="false">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-12 col-form-label form-control-label"
                                >
                                    <h3
                                        class="mb-0"
                                        v-if="params.id == '' || params.id == 0"
                                    >
                                        {{ $t("order_information") }}
                                    </h3>
                                    <h3 class="mb-0" v-else>
                                        {{ $t("order_information") }} :
                                        {{ this.params.id }}

										<template v-if="params.tracking_number != ''">
											- Tracking Number : {{ this.params.tracking_number }}
										</template>
                                    </h3>
                                </label>
                            </div>
                        </template>
                        <!-- Selected Product -->
                        <div class="row">
                            <div
                                class="col-lg-3"
                                v-for="o in order_items"
                                :key="o.id"
                            >
                                <div class="card">
                                    <img
                                        class="card-img-top"
                                        :src="GetProductImage(o.wms_product_id)"
                                        style="max-height:150px; width:150px;margin-left: auto; margin-right: auto;"
                                    />
                                    <div class="card-body">
                                        <h3>
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                            >
                                                {{ o.wms_product_name }}
                                            </span>
                                            <span v-else>
                                                {{ o.wms_product_name }}
                                            </span>
                                            (
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            <span v-else
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            )
                                        </h3>

                                        <div
                                            class="col-md-12 text-green"
                                            v-if="o.pickup_need == null"
                                        >
                                            {{ o.barcode }}
                                        </div>
                                        <div class="col-md-12" v-else>
                                            {{ o.barcode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>

		<modal :show.sync="showSyncModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >

            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('platform_order_id')" :name="$t('platform_order_id')" v-model="platform_order_id" rules="required"> </base-input>
            </form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handlePlatformSync()"
                >
                    Sync
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSyncModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { CouponService } from "../../resource";
import { json } from "d3";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            ProductTable: "WmsProduct/getData",
            PlatformTable: "Order/getPlatformTable",
            OrderStatusTable: "Order/OrderStatusTableWithAll"
        }),

        BarcodeTypeTable() {
            return [
                { id: 1, name: "Order" },
                { id: 2, name: "Tracking" },
            ];
        },

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    watch: {
        "params.platform_id": {
            handler: function(val) {
                switch (val) {
                    case 1: // self
                        this.params.barcode_type = 1;
                        break;
                    case 2: // Tiktoke
                        this.params.barcode_type = 2;
                    case 3: // shopee
                        this.params.barcode_type = 2;
                    case 4: // lazada
                        this.params.barcode_type = 2;
                    case 5: // line
                        this.params.barcode_type = 2;
                        break;
                }
                console.log("platform_id", val);
            },
            deep: true
        },
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
            lock: false,
            isWait: false,

            state: 0,
            barcode: "",
            first_barcode: "",
            pickup_items: [], // สินค้าที่หยิบใส่กล่องแล้ว
            order_items: [], // สินค้าที่เลือกจาก Order
            coupons: [],
            wms_items: [],
            isCloseFound: false,
            order_status: "",
            products:[],
            order:{},

            params: {
                id: 7,
                shipping_provider_id: 0,
                tracking_number: "",
                storage_id: "",
                barcode: "",
                platform_id: 1,
                barcode_type: 1
            },

			showSyncModal: false,
			platform_order_id:"",

            propsToSearch: []
        };
    },
    async mounted() {
        this.listStorage();
        this.listProduct();
        this.clearParam();

		try {
            let resp = await this.getProfile()
            let user = resp.data.Datum
            console.log(user)
            this.params.storage_id = user.wms_storage_id

            if (this.params.storage_id == 0) {
                swal.fire({
                    title: "ผู้ใช้งานนี้ยังไม่ได้ตั้งค่าคลังสินค้า",
                    text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false,
                }).then(()=>{
                    this.$router.go(-1)
                })

            }
        } catch (err){
            console.log(err)
            swal.fire({
                title: "ตรวจสอบข้อมูลคลังสินค้าผิดพลาด",
                text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                icon: "error",
                confirmButtonClass: "btn btn-danger btn-fill",
                buttonsStyling: false,
            }).then(()=>{
                this.$router.go(-1)
            })
        }
        },
    methods: {
        ...mapActions({
            listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
            listProduct: "WmsProduct/listData",
            addItem: "Packing/addPickupItem",
            removeItem: "Packing/removePickupItem",
            closeOrder: "Packing/closeShippingOrder",
			syncPlatformOrder : "Order/syncPlatformOrder",
			getProfile : "Auth/getProfile",
			shippingCreateAndClose: "Packing/shippingCreateAndCloseWithCoupon",
            ShippingCheckIsClose: "Packing/ShippingCheckIsClose"
        }),
        async handleBarcode() {

            if (this.isWait) {
                console.log("isLoading... , cancel this barcode");
                return;
            }

            this.isCloseFound = false
            this.params.barcode = this.barcode;
            this.order = {};
            this.coupons = [];

            try {
                let isOrder = this.params.barcode.startsWith("MDF");
                let orderId = this.params.barcode.replace("MDF", "");
                if (isOrder){
                    orderId = parseInt(orderId);
                } else {
                    orderId = parseInt(this.barcode);
                }

                let params = {
                    id: this.params.barcode_type == 1 ? orderId : 0,
                    storage_id: this.params.storage_id,
                    coupon_numbers : this.coupons,
                    barcode: this.params.barcode_type == 2 ?this.barcode: "",
                    platform_id : this.params.platform_id
                }

                console.log ("params", params)
                // this.isWait = false;
				// this.showModal = false;
				let resp = await this.ShippingCheckIsClose(params)
                this.isCloseFound = true
                this.order = resp.data.Datum.order
                this.coupons = resp.data.Datum.coupons

                // this.products = JSON.parse(this.order.product_list)
                this.products = this.parseProduct(this.order.product_list)
                this.wms_items = this.parseProduct(this.order.wms_product_summary)
                
                console.log("products", this.products)
                console.log("wms_items", this.wms_items)

                // find order status with orderstatustable
                this.order_status = this.OrderStatusTable.find(x => x.ID == this.order.order_status).Name

                console.log("resp", resp)

				// Success
				this.clearParam();
				
			}
			catch (err) {
				console.log(err)
                this.isWait = false;
				this.showModal = false;
                this.isCloseFound = false
				swal.fire({
					title: this.$t(err.response.data.Msg),
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}
        },
        parseProduct(productJson){
            try {
                let products = JSON.parse(productJson)
                return products
            } catch (err){
                return []
            }
        },
        handleLock() {
            //  check storage sleected
            if (this.params.storage_id == "") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            this.lock = true;
            this.isCloseFound = false;
            this.clearParam();
        },
        handleUnLock() {
            this.lock = false;
            this.isCloseFound = false;
            this.clearParam();
        },
        clearParam() {
            this.order_items = [];
            this.pickup_items = [];
            this.params.id = "";
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
            this.first_barcode = "";
            this.state = 0;
        },
        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms/" +
                    product.Image
                );
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}
</style>
